/**
 * Licensed Materials - Property of IBM
 * IBM Business Analytics (C) Copyright IBM Corp. 2018
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

/**
 * @class FredIsRedFeatureAPI
 * @hideconstructor
 * @classdesc
 */
define([], () => {
	class FredIsRedFeatureAPI {

	}



	// @todo : define APIs to statisfy the current visAPI functionality
	// getColor

	// see:
	// /Users/rnassif/dev/git/dashboard-livewidget/client/src/main/webapp/js/dashboard-analytics/visualizations/fredisred/FredIsRed.js


	return FredIsRedFeatureAPI;
});